import {
  ApiOutlined,
  AppstoreOutlined,
  BellOutlined,
  CreditCardFilled,
  QuestionCircleOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  TabletOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import {
  AccessAlarm,
  DashboardCustomizeOutlined,
  DescriptionOutlined,
  Feed,
  LocationOn,
  Phone,
  SystemUpdate,
} from "@mui/icons-material";
import { Layout, Menu } from "antd";
import React, { useState } from "react";
import { LogoWhiteSVG } from "../../assets/svg/SvgIcons";
import { PAYMENT_METHODS, ROLES } from "../../constants/strings";
import {
  APP_NAME,
  CAN_ADMIN,
  CAN_CATEGORIES,
  CAN_CONFIG,
  CAN_ORDERS,
  CAN_PAYMENTS,
  CAN_PRODUCTS,
  CAN_SHOPS,
  CAN_SUPPORT,
  CAN_USERS,
  FEED,
  PAYMENTS,
  REGIONS,
  TEMPLATES,
  TICKETS,
} from "../../constants/webapp";
import { getRegister } from "../../utils/helpers";
import { GetPermissions } from "../../utils/permissionUtils";
import { RecursiveMenu } from "./RecursiveMenu";

function getItem(label, to, icon, children, key) {
  return {
    label,
    to,
    icon,
    children,
    key,
  };
}

export const LeftMenu = () => {
  const { Sider } = Layout;
  const [collapsed, setCollapsed] = useState(false);

  // ITEMS

  const items = [
    getItem("Dashboard", "/", <AppstoreOutlined />, null, "1"),

    // PRODUCTS
    {
      label: "Products",
      to: "/products",
      icon: <ShoppingOutlined />,
      visible: GetPermissions([CAN_ADMIN, CAN_PRODUCTS]),
    },
    // CATEGORIES
    {
      label: "Categories",
      to: "/categories",
      icon: <DashboardCustomizeOutlined />,
      visible: GetPermissions([CAN_ADMIN, CAN_CATEGORIES]),
    },
    // SHOPS
    {
      label: "Shops",
      to: "/shops",
      icon: <ShopOutlined />,
      visible: GetPermissions([CAN_ADMIN, CAN_SHOPS]),
    },
    // ORDERS
    {
      label: "Orders",
      to: "/orders",
      icon: <ShoppingCartOutlined />,
      visible: GetPermissions([CAN_ADMIN, CAN_ORDERS]),
    },
    // PAYMENTS
    {
      label: PAYMENTS,
      to: getRegister(PAYMENTS),
      icon: <CreditCardFilled />,
      visible: GetPermissions([CAN_ADMIN, CAN_PAYMENTS]),
    },

    // NOTIFICATIONS
    getItem("Notifications", "/notifications", <BellOutlined />),

    // CONFIGS
    {
      label: "Configurations",
      icon: <ApiOutlined />,
      visible: GetPermissions([CAN_ADMIN, CAN_CONFIG]),
      children: [
        // TEMPLATES
        {
          label: TEMPLATES,
          to: getRegister(TEMPLATES),
          icon: <DescriptionOutlined />,
          visible: GetPermissions([CAN_ADMIN]),
        },
        getItem("Regions", getRegister(REGIONS), <LocationOn />),
        getItem(PAYMENT_METHODS, "/payment-methods", <CreditCardFilled />),
        getItem("Contacts", "/contacts", <Phone />),
        getItem("Version Control", "/version", <SystemUpdate />),
      ],
    },
    // MOBILE APP
    {
      label: "Mobile App",
      icon: <TabletOutlined />,
      visible: GetPermissions([CAN_ADMIN]),
      children: [getItem("Feed Management", getRegister(FEED), <Feed />)],
    },

    // USERS
    {
      label: "Users",
      icon: <TeamOutlined />,
      visible: GetPermissions([CAN_ADMIN, CAN_USERS]),
      children: [
        getItem("Customers", "/customers"),
        getItem("Staff", "/staff"),
      ],
    },
    // ROLES
    {
      label: ROLES,
      icon: <AccessAlarm />,
      visible: GetPermissions([CAN_ADMIN]),
      to: getRegister(ROLES),
    },

    // TICKETS
    {
      label: TICKETS,
      icon: <QuestionCircleOutlined />,
      to: getRegister(TICKETS),
      visible: GetPermissions([CAN_ADMIN, CAN_SUPPORT]),
    },

    // getItem("Settings", "/settings", <SettingOutlined />),
  ];

  return (
    <Sider
      style={{ zIndex: 1 }}
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <div className="demo-logo-vertical flexCenter whiteColor font12">
        <img
          alt="logo"
          src={LogoWhiteSVG}
          style={{
            width: 30,
            height: 30,
            margin: collapsed ? "10px 10px 10px 8px" : "0 10px 0 0",
          }}
        />
        {!collapsed && <h2>{APP_NAME}</h2>}
      </div>
      <Menu theme="dark" defaultSelectedKeys={["1"]} mode="inline">
        {RecursiveMenu(items)}
      </Menu>
    </Sider>
  );
};
